import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import DataTable from "../components/table/dataTable";
import { hasRoles, getTokenExpired } from "../components/utils";
import PageLayout from "../components/layouts/pageLayout";
import Button from "../components/ui/button";

const TutorAdminPage = () => {
    const [tutorModalTemplate, setTutorModalTemplate] = useState(1);
    const navigate = useNavigate();
    const tutorTableRef = useRef(null);

    useEffect(() => {
        if (getTokenExpired()) return navigate("/login");

        const checkTutorRole = async () => {
            try {
                if (!hasRoles("Admin")) {
                    navigate("/no-access");
                }
            } catch (error) {
                console.error("Error checking roles:", error);
                navigate("/no-access");
            }
        };

        checkTutorRole();
    }, [navigate]);

    const onCreateTutor = async () => {
        setTutorModalTemplate(tutorModalTemplate + 1);
        if (tutorTableRef.current) {
            await tutorTableRef.current.openModal("createTutor", []);
        }
    };

    return (
        <PageLayout title="Tutors">
            <DataTable tableId={1} ref={tutorTableRef} actionButton={<Button variant="contained" onClick={onCreateTutor}>+ Create Tutor </Button>}/>
        </PageLayout>
    );
};

export default TutorAdminPage;
